import { useRemoveCcEmailFromChatsDataMutation } from '../../../generated';

export const useRemoveEmailMutation = () => {
  const [removeEmail, { data, error, loading }] =
    useRemoveCcEmailFromChatsDataMutation();

  return {
    removeEmail,
    error,
    loading,
    numberOfChatsUpdated: data?.removeCCEmailFromChats.numberOfChatsUpdated,
  };
};
